export default "__VITE_ASSET__ffdb5fa0__"